export function Main({
  children,
  className,
}: React.PropsWithChildren<{ className?: string }>) {
  const additonalClasses = className ? ` ${className}` : "";
  return (
    <main className={"flex flex-col gap-8 p-8" + additonalClasses}>
      {children}
    </main>
  );
}
